// extracted by mini-css-extract-plugin
export default {"block":"Password_block__Jb4CU","eye":"Password_eye__A9Wde"};